import { Body, DialogContent, Textarea, useFlashMessage } from '@indigo-ag/component-module';
import React, { useEffect, useState } from 'react';

import i18next from 'core/i18n';
import { EnhancedDialog, ModalActionButtons, utils } from 'shared';
import { translateUpsertErrorMessage } from '../../utils/creditAnalysis.util';

interface SendAnalysisModalProps {
  closeModal: () => void;
  open: boolean;
  message: string;
  onConfirmAction: (notes: string) => Promise<any>;
}

export const SendAnalysisModal: React.FunctionComponent<SendAnalysisModalProps> = ({
  closeModal,
  open,
  message,
  onConfirmAction
}) => {
  /**
   * State
   */
  const [notes, setNotes] = useState('');

  useEffect(() => {
    setNotes('');
  }, [open]);

  const updateNotes = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setNotes(event.target.value);
  };

  const { addFlashMessage } = useFlashMessage();

  const sendAnalysis = () => {
    return onConfirmAction(notes)
      .then(() => {
        addFlashMessage({
          content: `${i18next.t('analysisSent')} ${i18next.t('successfully')}`,
          title: '',
          variant: 'success'
        });
      })
      .catch(e => {
        addFlashMessage({
          content: `${i18next.t('error')} - ${translateUpsertErrorMessage(e?.message)}`,
          title: '',
          variant: 'error'
        });
      });
  };

  return (
    <EnhancedDialog open={open} onClose={closeModal} title={i18next.t('sendAnalysis')}>
      <DialogContent>
        <Body className="mb-4">{utils.text.firstLetterUppercase(message)}</Body>
        <Textarea
          label={`${i18next.t('commentsOrRecommendations')} (${i18next.t('optional')})`}
          name="notes"
          rows={3}
          onChange={updateNotes}
          value={notes}
        />
      </DialogContent>
      <ModalActionButtons
        closeModal={closeModal}
        save={sendAnalysis}
        changeButtonName={i18next.t('send')}
        disabled={false}
      />
    </EnhancedDialog>
  );
};
